import { ShieldCheck } from "lucide-react";
import { INSURANCE_PARTNERS } from "../lib/constants";

export default function InsurancePartners() {
  return (
    <section
      data-testid="insurance-section"
      className="max-w-7xl mx-auto px-4 md:px-8 py-20"
    >
      <div className="rounded-3xl border border-slate-200 bg-white p-8 md:p-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-5 space-y-4">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700">
              <ShieldCheck className="w-4 h-4" /> Assurances acceptées
            </div>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 leading-tight">
              Facture acceptée pour
              <br />
              <span className="text-teal-600">remboursement assurance.</span>
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Toutes nos prestations donnent lieu à une <strong>facture détaillée</strong>{" "}
              acceptée par la quasi-totalité des compagnies d'assurance. Après une
              effraction ou une intervention d'urgence, vous pouvez la transmettre
              directement à votre assureur pour <strong>remboursement</strong>.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {INSURANCE_PARTNERS.map((p) => (
                <div
                  key={p.name}
                  data-testid={`insurance-${p.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                  className={`group flex items-center justify-center min-h-[88px] p-4 transition-all hover:-translate-y-0.5 hover:shadow-md ${
                    p.logo
                      ? "bg-white border border-slate-200 rounded-2xl"
                      : p.style === "rounded"
                      ? "rounded-full"
                      : "rounded-2xl"
                  }`}
                  style={!p.logo ? { backgroundColor: p.bg } : undefined}
                >
                  {p.logo ? (
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="max-h-12 md:max-h-14 w-auto object-contain"
                      loading="lazy"
                    />
                  ) : (
                    <span
                      className="font-display font-black uppercase tracking-tight text-lg md:text-xl text-center leading-none"
                      style={{ color: p.color, letterSpacing: "-0.02em" }}
                    >
                      {p.name}
                    </span>
                  )}
                </div>
              ))}
            </div>
            <p className="text-xs text-slate-500 mt-4 italic">
              Liste non exhaustive · Demandez à votre assureur si votre
              facture est éligible au remboursement.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
